import Svg, { Ellipse } from 'react-native-svg';
import Colors from '../../constants/Colors';

const DrawEllipse = (props) => {
  const { drawPoints } = props;

  if (drawPoints.length < 4) return null;

  const p0 = drawPoints[0];
  const p1 = drawPoints[1];
  const p2 = drawPoints[2];
  const p3 = drawPoints[3];

  const centerX = (p0.x + p2.x) / 2;
  const centerY = (p0.y + p2.y) / 2;

  const vectorA = { x: p1.x - p0.x, y: p1.y - p0.y };
  const vectorB = { x: p3.x - p0.x, y: p3.y - p0.y };

  const lengthA = Math.sqrt(vectorA.x ** 2 + vectorA.y ** 2);
  const lengthB = Math.sqrt(vectorB.x ** 2 + vectorB.y ** 2);

  const radiusX = lengthB / 2;
  const radiusY = lengthA / 2;

  return (
      <Svg
        style={{
          zIndex: 1,
          width: '100%',
          height: '100%',
          position: 'absolute',
        }}
      >
        <Ellipse
          cx={centerX}
          cy={centerY}
          rx={radiusX}
          ry={radiusY}
          fill={'none'}
          stroke={Colors.light.hereworksOrange500}
          strokeWidth={2}
        />
        <Ellipse
          cx={centerX}
          cy={centerY}
          rx={radiusX}
          ry={radiusY}
          fill={Colors.light.hereworksBlue200}
          opacity={0.3}
        />
      </Svg>
  );
};

export default DrawEllipse;
